export const Program = () => {
    return(
        <>
        <div id="program" className="block-program">
            <h2 className="h2-program">Program</h2>
            <p className="page-program">Twinschools offers two programs for students different ages. Learn more about our programs</p>
            <div className="program">
                <div className="item-block">
                    <img src="./img/program.png" alt="program" />
                    <h3 className="title-program">Program for</h3>
                    <h4 className="group-program">6-8 grades</h4>
                    <div className="learn-more">
                        <div className="info-learn-block">
                        <svg width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.6248 2.5H13.7498V0.75H11.9998V2.5H4.99976V0.75H3.24976V2.5H2.37476C1.40351 2.5 0.633506 3.2875 0.633506 4.25L0.624756 16.5C0.624756 17.4625 1.40351 18.25 2.37476 18.25H14.6248C15.5873 18.25 16.3748 17.4625 16.3748 16.5V4.25C16.3748 3.2875 15.5873 2.5 14.6248 2.5ZM14.6248 16.5H2.37476V7.75H14.6248V16.5ZM5.87476 11.25H4.12476V9.5H5.87476V11.25ZM9.37476 11.25H7.62476V9.5H9.37476V11.25ZM12.8748 11.25H11.1248V9.5H12.8748V11.25ZM5.87476 14.75H4.12476V13H5.87476V14.75ZM9.37476 14.75H7.62476V13H9.37476V14.75ZM12.8748 14.75H11.1248V13H12.8748V14.75Z" fill="#254682"/>
                        </svg>
                            <h3 className="time-program">8 weeks</h3>
                        </div>
                        <button className="button-program">
                            <a href="https://drive.google.com/file/d/1alv5Ntxs4j3ZjM5DbXLetAvZVHe8OAkr/view" target="blank">Learn more</a>
                        </button>
                    </div>
                </div>
                <div className="item-block2">
                    <img src="./img/program.png" alt="" />
                    <h3 className="title-program">Program for</h3>
                    <h4 className="group-program">9-12 grades</h4>
                        <div className="learn-more">
                            <div className="info-learn-block">
                        <svg width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.6248 2.5H13.7498V0.75H11.9998V2.5H4.99976V0.75H3.24976V2.5H2.37476C1.40351 2.5 0.633506 3.2875 0.633506 4.25L0.624756 16.5C0.624756 17.4625 1.40351 18.25 2.37476 18.25H14.6248C15.5873 18.25 16.3748 17.4625 16.3748 16.5V4.25C16.3748 3.2875 15.5873 2.5 14.6248 2.5ZM14.6248 16.5H2.37476V7.75H14.6248V16.5ZM5.87476 11.25H4.12476V9.5H5.87476V11.25ZM9.37476 11.25H7.62476V9.5H9.37476V11.25ZM12.8748 11.25H11.1248V9.5H12.8748V11.25ZM5.87476 14.75H4.12476V13H5.87476V14.75ZM9.37476 14.75H7.62476V13H9.37476V14.75ZM12.8748 14.75H11.1248V13H12.8748V14.75Z" fill="#254682"/>
                        </svg>
                                <h3 className="time-program">8 weeks</h3>
                            </div>
                            <button className="button-program">
                                <a href="https://drive.google.com/file/d/1alv5Ntxs4j3ZjM5DbXLetAvZVHe8OAkr/view" target="blank">Learn more</a>
                            </button>
                        </div>
                </div>
            </div>
        </div>
        </>
    );
}